import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from '@sm/wds-react';
import { getAuthFooterLinks } from './helpers';
import { InlineList, InlineListItem } from '../InlineList';

const AuthedFooterLinks = ({ domain, lang }) => {
  const links = getAuthFooterLinks(domain, lang);
  return (
    <Row>
      <Col>
        <InlineList noMargin>
          {links.map((item, index) => {
            return (
              <InlineListItem
                href={item.url}
                // eslint-disable-next-line react/no-array-index-key
                key={`${item.title}-${index}`}
              >
                {item.title}
              </InlineListItem>
            );
          })}
        </InlineList>
      </Col>
    </Row>
  );
};

AuthedFooterLinks.propTypes = {
  domain: PropTypes.string,
  lang: PropTypes.string,
};

AuthedFooterLinks.defaultProps = {
  domain: 'surveymonkey',
  lang: 'en',
};

export default AuthedFooterLinks;
